module.exports = __webpack_public_path__ + "img/Ministry_of_AF_logo.4a5bb7d9.png";